import { z } from 'zod'
import { oc } from '@orpc/contract'

export const scribeChunkSchema = z.object({
  text: z.string(),
  speaker: z.string().optional(),
  timestamp: z.string().optional(),
})
export type ScribeChunk = z.infer<typeof scribeChunkSchema>

export const getSessionChunksResponseSchema = z.object({
  sessionId: z.string(),
  chunks: z.array(scribeChunkSchema),
})
export type GetSessionChunksResponse = z.infer<typeof getSessionChunksResponseSchema>

export const scribeGetSessionChunks = oc
  .route({ method: 'GET', path: '/v2/scribe/sessions/{encounterId}/{sessionId}/chunks' })
  .input(z.object({ encounterId: z.string(), sessionId: z.string() }))
  .output(getSessionChunksResponseSchema)
